import React from 'react';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { Column } from '../../components/column';
import { Text } from '../../components/text';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { BdiWrapper } from '../../components/bdi-wrapper';
import { cleanFont } from '../../utils/font-utils/clean-font';
import { addBorderClasses } from './common';
import MobileDivider from './mobile-divider';
import FooterSocialIcon from './footer-social-icon';
const WRAP_STYLES = { whiteSpace: 'normal' };
const NO_WRAP_STYLES = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
};
export const FooterSocialIconsSection = ({ wrap, buttons, isVisible, shareViaTitle, showBorderLeft, showBorderRight, showCustomShareViaTitle, width, section, paddingLeft, paddingRight, isRtl, onShareClick, }) => {
    const { t } = useTranslation();
    return isVisible ? (React.createElement(Column, { cssClass: `html-emails-footer-section ${addBorderClasses({
            showBorderRight,
            showBorderLeft,
            isRtl,
        })} bigger-column-height ${mobileFullWidthColumnClassName}`, direction: isRtl ? 'rtl' : 'ltr', verticalAlign: "middle", width: width, paddingLeft: paddingLeft, paddingRight: paddingRight },
        React.createElement(MobileDivider, { section: section, show: showBorderLeft }),
        React.createElement(Text, { align: "center", paddingTop: "0px", paddingBottom: "0px", paddingRight: "10px", paddingLeft: "10px" },
            getShareVia(),
            React.createElement("p", { style: wrap ? WRAP_STYLES : NO_WRAP_STYLES }, buttons.map((button, index, array) => (React.createElement(FooterSocialIcon, { key: button.src, wrap: !!wrap, spacing: index + 1 < array.length, ...button, onShareClick: onShareClick, alt: t(button.alt) }))))),
        React.createElement(MobileDivider, { section: section, show: showBorderRight }))) : null;
    function getShareVia() {
        if (showCustomShareViaTitle && !shareViaTitle) {
            return null;
        }
        const content = showCustomShareViaTitle ? (React.createElement(BdiWrapper, { text: shareViaTitle })) : (React.createElement(Trans, { i18nKey: "COMPOSER.FOOTER.SHARE_VIA" }));
        return (React.createElement("p", { className: "so-global-footer-text", style: {
                color: section.textColor,
                ...(section.fontFamily
                    ? { fontFamily: cleanFont(section.fontFamily) }
                    : {}),
                marginBottom: '10px',
            } }, content));
    }
};
//# sourceMappingURL=footer-social-icons-section.js.map